import { ACCESS_MODE } from '@/lib/api';
import { useAuthStore } from '@/stores/auth';

// The guard both layouts share. It is NOT a `beforeLoad` redirect: `initialize()` resolves the
// Supabase session asynchronously, and beforeLoad would fire against the persisted-but-unverified
// flag before that lands. Render nothing until it settles — a flash of the shell for a signed-out
// user is worse than a blank frame.
export function RequireAuth({ children }: { children: React.ReactNode }): React.ReactNode {
  const { isAuthenticated, isLoading } = useAuthStore();

  // UNDER CLOUDFLARE ACCESS THERE IS NOTHING TO GUARD, and guarding anyway is a lockout.
  //
  // Access authenticates at the EDGE: an unauthenticated request never reaches this bundle — it is
  // answered with a login page by Cloudflare, and the app is not served at all. So by the time this
  // component runs, the person is authenticated, by definition.
  //
  // Checking for a Supabase session here would find none (we did not configure Supabase), redirect
  // to `/login`, and land the author on a sign-in form for a provider that does not exist. The
  // dashboard would be unreachable while being perfectly well authenticated — which is a worse bug
  // than being locked out, because everything looks like it is working.
  //
  // This is NOT trusting the client. The Worker independently verifies the `Cf-Access-Jwt-Assertion`
  // Access injects (issuer AND audience), so a forged page here buys nothing: every `/api/*` call
  // still has to get past the edge and then past the Worker.
  if (ACCESS_MODE) return children;

  if (isLoading) return null;
  if (!isAuthenticated) {
    window.location.replace('/login');
    return null;
  }
  return children;
}
